import { render, staticRenderFns } from "./CustomCheckboxRound.vue?vue&type=template&id=b0b9ab0c&scoped=true&lang=pug"
import script from "./CustomCheckboxRound.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxRound.vue?vue&type=script&lang=js"
import style0 from "./CustomCheckboxRound.vue?vue&type=style&index=0&id=b0b9ab0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9ab0c",
  null
  
)

export default component.exports